export default __webpack_public_path__ + "static/media/HelveticaBold.31428389.otf";